// The full-screen route for a seat's brief, at `/plans/:planId/sheet`. Shown on arrival
// (`DemoScenarios.tsx` navigates here the moment a demo starts) and reachable afterwards
// from the plan's own "about" drawer (`DecisionsPanel.tsx`), which is what "stays one tap
// away afterwards" means in practice on a desktop screen — and, on a screen too narrow for
// that drawer, the only way back to the brief at all; see `DecisionsPanel.tsx`'s header
// comment for why mobile carries no equivalent tab.
//
// The fetch, the three states it can resolve to, and the markdown render itself all live
// in `CharacterBrief.tsx` now, shared with that drawer — this screen is just that,
// framed with a heading and a way back to the plan.

import { Link, useParams } from 'react-router-dom';

import type { ApiClient } from '../api/client.js';
import { CharacterBrief } from '../components/CharacterBrief.js';

export type CharacterSheetProps = {
  client: ApiClient;
};

export function CharacterSheet({ client }: CharacterSheetProps): JSX.Element {
  const { planId } = useParams<{ planId: string }>();
  const backLink = planId === undefined ? '/' : `/plans/${planId}`;

  return (
    <main className="screen screen--sheet">
      <div className="sheetHead">
        <h1 className="screen__title">Your character</h1>
        <Link className="button button--outline" to={backLink}>
          Back to the plan
        </Link>
      </div>
      <CharacterBrief client={client} planId={planId ?? ''} />
    </main>
  );
}
